<div class="flex h-screen overflow-hidden bg-slate-50">
  <app-sidebar [menuItems]="menuItems"></app-sidebar>

  <main class="flex-1 flex flex-col min-w-0">
    <!-- Combined Sticky Header -->
    <div class="sticky top-0 z-[500] bg-white border-b border-slate-50 shadow-xs">
      <!-- Row 1: Back & Breadcrumb -->
      <div class="px-8 py-3 flex items-center justify-between border-b border-slate-50 bg-white">

        <app-breadcrumb [breadcrumbs]="breadcrumbs" [parentRoute]="parentRoute"></app-breadcrumb>

      </div>


    </div>

    <!-- Main Content Area -->
    <div class="flex-1 overflow-y-auto p-8 lg:p-10 bg-white">
      <div class="max-w-[90rem] mx-auto">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>
</div>
